import type { Permission } from "@lib/permissionConstants";

import type { DeveloperPermissionMap } from "@services/useDeveloper/types";

import type { CompanyId, AppGroupId, TeamId } from "./types";

export function developerTeamsWithPermission(
  developerPermissions: DeveloperPermissionMap,
  companyId: CompanyId,
  appGroupId: AppGroupId,
  permission: Permission
) {
  const emptyPermissionInfo = {
    company: new Set<string>(),
    appGroups: new Set<string>(),
    anyTeam: new Set<string>(),
    teams: new Map<string, Set<string>>(),
  };
  const adminPermissionInfo = developerPermissions.get("admin") || emptyPermissionInfo;
  const permissionInfo = developerPermissions.get(permission) || emptyPermissionInfo;
  const qualifiedAppGroupId = `${companyId}-${appGroupId}`;

  if (
    adminPermissionInfo.company.has(companyId) ||
    permissionInfo.company.has(companyId) ||
    adminPermissionInfo.appGroups.has(qualifiedAppGroupId) ||
    permissionInfo.appGroups.has(qualifiedAppGroupId)
  ) {
    return {
      permission: permission,
      appGroupId: appGroupId,
      hasPermissionForAppGroup: true,
      teamIdsWithPermission: null,
    };
  }

  return {
    permission: permission,
    appGroupId: appGroupId,
    hasPermissionForAppGroup: false,
    teamIdsWithPermission: new Set([
      ...(adminPermissionInfo.teams.get(qualifiedAppGroupId) || []),
      ...(permissionInfo.teams.get(qualifiedAppGroupId) || []),
    ]) as ReadonlySet<TeamId>,
  };
}
